import { render, staticRenderFns } from "./ProductChannelTable.vue?vue&type=template&id=1666298e&scoped=true"
import script from "./ProductChannelTable.vue?vue&type=script&lang=js"
export * from "./ProductChannelTable.vue?vue&type=script&lang=js"
import style0 from "./ProductChannelTable.vue?vue&type=style&index=0&id=1666298e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1666298e",
  null
  
)

export default component.exports